import { render, staticRenderFns } from "./sider-trigger.vue?vue&type=template&id=d2d909d6&"
import script from "./sider-trigger.vue?vue&type=script&lang=js&"
export * from "./sider-trigger.vue?vue&type=script&lang=js&"
import style0 from "./sider-trigger.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sider-trigger.vue"
export default component.exports